/**
 * Returns true when HTML contains meaningful text content.
 * Treats tags, line breaks and non-breaking spaces as non-content.
 */
export function hasMeaningfulHtmlTextContent(html: string): boolean {
  const textOnly = html
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim()

  return textOnly.length > 0
}
